import type { ApiError } from './ApiError';

/**
 * The network never reached the API.
 *
 * A separate type because there is no status and no correlation id to show — and because the browser's
 * own message ("Failed to fetch") is English written for a developer, and easily read as a rejected
 * password. The cause is kept for the console, never for the screen.
 */
export class ApiNetworkError extends Error {
  public readonly baseUrl: string;
  public readonly cause: unknown;

  public constructor(baseUrl: string, cause: unknown) {
    super('Network failure');
    this.baseUrl = baseUrl;
    this.cause = cause;
  }
}

/** The API answered with an error. Its `message` is already a sentence in the language we asked for. */
export class ApiRequestError extends Error {
  public readonly status: number;
  public readonly errorCode: string;
  public readonly correlationId: string;

  public constructor(error: ApiError) {
    super(error.message);
    this.status = error.statusCode;
    this.errorCode = error.errorCode;
    this.correlationId = error.correlationId;
  }
}
